import { hasProperty } from "./utils";
/**
 * This function is similar to getCellTextAlignmentClass just that the params are different
 */
export const getTextAlignmentClass = (columnData, props) => {
  const alignment = hasProperty(columnData, "textAlign")
    ? columnData.textAlign
    : props.textAlign;
  return `oui-text-${alignment}`;
};

/**
 * This function will get the table and find the header nodes in that table.
 * Then will iterate over all the headers to find the max clientHeight
 * And then that will be the new headerHeight for the given table.
 * @param {*} Unique id for the table
 * @param {*} Optionally header class to find the header node
 */
export const getMaxHeaderHeight = (
  tableId,
  headerClass = "oui-header-cell"
) => {
  let maxHeaderHeight = 0;
  try {
    const headersNodes = document
      .getElementById(tableId)
      .getElementsByClassName(headerClass);
    if (headersNodes.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const element of headersNodes) {
        const elementClientHeight = element.clientHeight + 20;
        if (elementClientHeight > maxHeaderHeight) {
          maxHeaderHeight = elementClientHeight;
        }
      }
    }
    // eslint-disable-next-line no-empty
  } catch (err) {}
  return maxHeaderHeight;
};

/**
 * This function is designed to return the cell alignment
 */
export const getCellTextAlignmentClass = (data, props) => {
  const { columnsDef } = props;
  const columnData = columnsDef[data.columnIndex];
  return getTextAlignmentClass(columnData, props);
};

/**
 * This function will return the flex based classes for the header container
 */
export const getHeaderContentAlignmentClass = (columnData, props) => {
  const alignment = hasProperty(columnData, "textAlign")
    ? columnData.textAlign
    : props.textAlign;
  return {
    left: "oui-justify-content-start",
    center: "oui-justify-content-center",
    right: "oui-justify-content-end"
  }[alignment];
};
